<template>
  <div class="i-job-test">
    <template v-if="isQuizCompleted || isQuizError">
      <iBackground />
    </template>

    <iNavbarSimple />

    <div v-show="isQuizStarted">
      <div class="container-qubl">
        <iQublQuiz
          ref="qublQuiz"
          :quiz-id="GlobalFunctions.getQublQuizId()"
          :quiz-style="GlobalFunctions.getQublStyle()"
          @quiz-completed="onQuizCompleted"
          @quiz-success="onQuizSuccess"
        />
      </div>
    </div>

    <div v-if="isQuizCompleted">
      <div class="container-loader">
        <iLoaderSimple :loading-animation-duration-ms="data.loadingAnimationDurationMs">
          <template #title>Success!</template>
          <template #subtitle>We are processing your response...</template>
        </iLoaderSimple>
      </div>
    </div>

    <div v-if="isQuizError">
      <div class="container-error-general">
        <iBaseErrorCard
          button-text="Back to Jobtest.org"
          @clicked-logo="goToHome()"
          @clicked-button="goToHome()"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue"
import { useRouter } from "vue-router"

import { GlobalFunctions } from "@/helpers/globalFunctions"
import { GlobalVariables } from "@/helpers/globalVariables"
import QuizService from "@/services/quizService"

import type { QuizData } from "@/types/quizData"

import iBaseErrorCard from "@/components/base/BaseErrorCard.vue"
import iBackground from "@/components/global/Background.vue"
import iLoaderSimple from "@/components/global/LoaderSimple.vue"
import iNavbarSimple from "@/components/global/NavbarSimple.vue"

import iQublQuiz from "@/views/jobTest/sections/QublQuizOauth.vue"

// REFS
const qublQuiz = ref(null)

// ROUTER
const router = useRouter()

// DATA

const data = reactive({
  loadingAnimationDurationMs: 4000,
  quizData: {} as QuizData,
  quizStatus: QuizService.QUIZ_STATUSES.STARTED,
  quizErrorMessageHTML: QuizService.ERROR_MESSAGES["DEFAULT"],
  userName: "",
  userZipCode: ""
})

// COMPUTED

const isQuizStarted = computed(() => {
  return data.quizStatus === QuizService.QUIZ_STATUSES.STARTED
})

const isQuizCompleted = computed(() => {
  return data.quizStatus === QuizService.QUIZ_STATUSES.COMPLETED
})

const isQuizError = computed(() => {
  return data.quizStatus === QuizService.QUIZ_STATUSES.ERROR
})

// FUNCTIONS

function goToHome() {
  window.location.href = GlobalVariables.urls.website.path
}

function onQuizCompleted() {
  data.quizStatus = QuizService.QUIZ_STATUSES.COMPLETED
}

function onQuizSuccess(payload: { full_name: string; zip_code: string; test_purpose: string }) {
  router.push({
    name: GlobalVariables.urls.register.routeName,
    query: payload
  })
}
</script>

<style scoped lang="scss">
.i-job-test {
  .container-qubl,
  .container-loader,
  .container-error-email,
  .container-error-general {
    height: calc(100vh - 90px);
    margin-left: auto;
    margin-right: auto;
    width: 90%;
  }

  .container-qubl {
    margin-top: 10px;
    max-width: $section-max-width;
  }

  .container-loader {
    margin-top: -60px;
    max-width: $section-max-width;
  }

  .container-error-email {
    @include flex($justify: center, $align: center);

    max-width: 550px;
    margin-top: -30px;
  }

  .container-error-general {
    @include flex($justify: center, $align: center);

    max-width: 450px;
    margin-top: -30px;
  }
}
</style>
